<div class="layout-wrapper d-lg-flex">
  <!-- start chat-leftsidebar -->
  <div class="chat-leftsidebar mr-lg-1">
    <!-- Start side-menu nav -->
    <div class="flex-lg-column my-auto" style="height: 64px">
      <ul
        class="nav nav-pills side-menu-nav justify-content-center"
        role="tablist"
      >
        <li
          class="nav-item"
          matTooltip="{{ 'chat.chats' | translate: 'Чаты' }}"
        >
          <a
            class="nav-link active"
            id="pills-chat-tab"
            (click)="activetab = 2"
            [ngClass]="{ active: activetab === 2 }"
          >
            <mat-icon
              matBadge="{{ unreadChat }}"
              [matBadgeHidden]="unreadChat < 1"
              matBadgeOverlap="true"
              matBadgePosition="above"
              matBadgeColor="warn"
              matBadgeSize="small"
            >
              chat</mat-icon
            >
          </a>
        </li>
        <li
          class="nav-item"
          matTooltip="{{ 'chat.groups' | translate: 'Группы' }}"
        >
          <a
            class="nav-link"
            id="pills-groups-tab"
            (click)="activetab = 3"
            [ngClass]="{ active: activetab === 3 }"
          >
            <mat-icon
              matBadge="{{ unreadGroup }}"
              [matBadgeHidden]="unreadGroup < 1"
              matBadgeOverlap="true"
              matBadgePosition="above"
              matBadgeColor="warn"
              matBadgeSize="small"
              >group</mat-icon
            >
          </a>
        </li>
      </ul>
    </div>
    <!-- end side-menu nav -->

    <div
      class="tab-content"
      style="flex-grow: 1; min-height: 0; position: relative"
    >
      <!-- Start chats tab-pane -->
      <div
        id="pills-chat"
        role="tabpanel"
        aria-labelledby="pills-chat-tab"
        *ngIf="activetab === 2"
        style="height: 100%"
      >
        <app-chats></app-chats>
      </div>
      <!-- End chats tab-pane -->

      <!-- Start groups tab-pane -->
      <div
        id="pills-groups"
        role="tabpanel"
        aria-labelledby="pills-groups-tab"
        *ngIf="activetab === 3"
        style="height: 100%"
      >
        <app-groups></app-groups>
      </div>
      <!-- End groups tab-pane -->
    </div>
  </div>

  <!-- Start User chat -->
  <div
    class="user-chat w-100"
    id="chat-room"
    [class.user-chat-show]="dataService.activChatId !== null"
    [ngClass]="{ 'no-chat-selected': dataService.activChatId === null }"
  >
    <div class="d-lg-flex" style="height: 100%">
      <!-- start chat conversation section -->
      <div class="w-100 chat-main-container">
        <div
          *ngIf="dataService.activChatId !== null"
          class="p-3 p-lg-4 border-bottom"
          style="padding: 0.72rem !important"
        >
          <div
            class="d-flex align-items-center"
            [ngClass]="{
              'search-mode-mobile': isMobileView && isSearchExpanded
            }"
          >
            <div class="chat-header-info">
              <div
                *ngIf="dataService.activChat"
                class="media align-items-center"
              >
                <div class="d-block d-lg-none mr-2">
                  <a
                    href="javascript: void(0);"
                    class="user-chat-remove text-muted font-size-16 p-2"
                    (click)="closeUserChat()"
                  >
                    <mat-icon>keyboard_arrow_left</mat-icon>
                  </a>
                </div>
                <ng-container *ngIf="!(isMobileView && isSearchExpanded)">
                  <div
                    *ngIf="!dataService.isGroupChat && dataService.activChatId"
                    class="media align-items-center"
                    style="flex: 1; min-width: 0"
                  >
                    <div
                      class="chat-user-img align-self-center mr-3"
                      [ngClass]="{
                        online: dataService.activChat.isOnline,
                        away: !dataService.activChat.isOnline
                      }"
                    >
                      <img
                        style="height: 36px !important"
                        *ngIf="dataService.activChat.img"
                        src="{{ dataService.activChat.img }}"
                        class="rounded-circle avatar-xs"
                        alt=""
                      />
                      <div class="avatar-xs" *ngIf="!dataService.activChat.img">
                        <span
                          style="height: 36px !important"
                          class="avatar-title rounded-circle"
                        >
                          {{
                            dataService.activChat.name.split(' ')[0].charAt(0) +
                              dataService.activChat.name.split(' ')[1].charAt(0)
                          }}
                        </span>
                      </div>
                      <span class="user-status"></span>
                    </div>
                    <div class="groupName media-body overflow-hidden">
                      <h5 class="text-truncate font-size-15 mb-1">
                        {{ dataService.activChat.name }}
                      </h5>
                    </div>
                  </div>
                  <div
                    *ngIf="dataService.isGroupChat && dataService.activChatId"
                    class="groupName media-body overflow-hidden"
                  >
                    <h5 class="font-size-16 mb-0 d-flex align-items-baseline">
                      <span
                        class="subject-color-dot mr-2"
                        [style.backgroundColor]="groupColor"
                      ></span>
                      <a class="text-reset user-profile-show text-truncate">{{
                        dataService.activChat.name
                      }}</a>
                      <span
                        class="subject-name-in-header"
                        *ngIf="parentSubjectName"
                      >
                        <ng-container *ngIf="!isMobileView">{{
                          parentSubjectName
                        }}</ng-container>
                        <ng-container *ngIf="isMobileView">{{
                          parentSubjectShortName
                        }}</ng-container>
                      </span>
                      <span
                        *ngIf="dataService.activChat?.isCompletedForUser"
                        class="badge badge-warning ml-2"
                        >{{
                          'chat.readOnlyBadge' | translate: 'Только чтение'
                        }}</span
                      >
                    </h5>
                  </div>
                </ng-container>
              </div>
            </div>
            <div>
              <ul class="list-inline user-chat-nav text-right mb-0">
                <li
                  class="list-inline-item sliding-search-container search-list-item"
                >
                  <div
                    class="search-field-wrapper"
                    [ngClass]="{ expanded: isSearchExpanded }"
                  >
                    <input
                      #searchInput
                      type="text"
                      class="form-control border-0 search-input"
                      placeholder="{{
                        'chat.filter' | translate: 'Поиск сообщений'
                      }}"
                      [(ngModel)]="filterValue"
                      (ngModelChange)="filter()"
                      (keyup.enter)="filter()"
                      (keyup.escape)="closeSearch()"
                      autocomplete="off"
                    />
                    <button
                      *ngIf="filterValue && isSearchExpanded"
                      class="btn btn-sm clear-search-btn"
                      (click)="clearSearch()"
                      matTooltip="{{ 'button.clear' | translate: 'Очистить' }}"
                    >
                      <mat-icon style="font-size: 18px">close</mat-icon>
                    </button>
                  </div>
                  <button
                    class="btn nav-btn search-toggle-btn"
                    (click)="toggleSearch()"
                    matTooltip="{{
                      isSearchExpanded
                        ? ('chat.closeSearch' | translate: 'Закрыть поиск')
                        : ('chat.filter' | translate: 'Поиск сообщений')
                    }}"
                  >
                    <mat-icon>{{
                      isSearchExpanded ? 'arrow_forward' : 'search'
                    }}</mat-icon>
                  </button>
                </li>
                <li
                  class="list-inline-item"
                  *ngIf="
                    dataService.isLecturer &&
                    dataService.isGroupChat &&
                    dataService.activChat.groupId &&
                    !(isMobileView && isSearchExpanded)
                  "
                >
                  <button
                    class="btn nav-btn"
                    (click)="openStudentsList()"
                    matTooltip="{{
                      'chat.listStudent' | translate: 'Список студентов'
                    }}"
                  >
                    <mat-icon>list_alt</mat-icon>
                  </button>
                </li>
                <ng-container
                  *ngIf="
                    dataService.isGroupChat &&
                    !(isMobileView && isSearchExpanded)
                  "
                >
                  <ng-container *ngIf="dataService.isLecturer">
                    <li
                      *ngIf="
                        !(dataService.activeGroupCalls | async)?.has(
                          dataService.activChatId
                        )
                      "
                      class="list-inline-item"
                    >
                      <button
                        (click)="startGroupCall()"
                        class="btn nav-btn"
                        matTooltip="{{
                          'videochat.startGroupCallTooltip'
                            | translate: 'Начать групповой звонок'
                        }}"
                      >
                        <mat-icon>videocam</mat-icon>
                      </button>
                    </li>

                    <ng-container
                      *ngIf="
                        (dataService.activeGroupCalls | async)?.has(
                          dataService.activChatId
                        )
                      "
                    >
                      <li
                        *ngIf="
                          (videoChatService.activeGroupCallId | async) !==
                          dataService.activChatId
                        "
                        class="list-inline-item"
                      >
                        <button
                          (click)="joinGroupCall()"
                          class="btn nav-btn"
                          matTooltip="{{
                            'videochat.rejoinGroupCallTooltip'
                              | translate: 'Вернуться в звонок'
                          }}"
                        >
                          <mat-icon>login</mat-icon>
                        </button>
                      </li>
                      <li
                        *ngIf="
                          (videoChatService.activeGroupCallId | async) ===
                          dataService.activChatId
                        "
                        class="list-inline-item"
                      >
                        <button
                          (click)="leaveGroupCall()"
                          class="btn nav-btn text-danger"
                          matTooltip="{{
                            'videochat.leaveGroupCallTooltip'
                              | translate: 'Покинуть звонок'
                          }}"
                        >
                          <mat-icon>logout</mat-icon>
                        </button>
                      </li>
                      <li class="list-inline-item">
                        <button
                          (click)="endGroupCall()"
                          class="btn nav-btn text-danger"
                          matTooltip="{{
                            'videochat.endGroupCallTooltip'
                              | translate: 'Завершить групповой звонок'
                          }}"
                        >
                          <mat-icon>call_end</mat-icon>
                        </button>
                      </li>
                    </ng-container>
                  </ng-container>

                  <ng-container *ngIf="!dataService.isLecturer">
                    <li
                      *ngIf="
                        (dataService.activeGroupCalls | async)?.has(
                          dataService.activChatId
                        ) &&
                        (videoChatService.activeGroupCallId | async) !==
                          dataService.activChatId
                      "
                      class="list-inline-item"
                    >
                      <button
                        (click)="joinGroupCall()"
                        class="btn nav-btn"
                        matTooltip="{{
                          'videochat.joinGroupCallTooltip'
                            | translate: 'Присоединиться к звонку'
                        }}"
                      >
                        <mat-icon>login</mat-icon>
                      </button>
                    </li>
                    <li
                      *ngIf="
                        (videoChatService.activeGroupCallId | async) ===
                        dataService.activChatId
                      "
                      class="list-inline-item"
                    >
                      <button
                        (click)="leaveGroupCall()"
                        class="btn nav-btn text-danger"
                        matTooltip="{{
                          'videochat.leaveGroupCallTooltip'
                            | translate: 'Покинуть звонок'
                        }}"
                      >
                        <mat-icon>logout</mat-icon>
                      </button>
                    </li>
                  </ng-container>
                </ng-container>
                <li
                  class="list-inline-item"
                  *ngIf="
                    isAllowedForUser() &&
                    !dataService.isGroupChat &&
                    !(isMobileView && isSearchExpanded)
                  "
                >
                  <button
                    type="button"
                    (click)="startCall()"
                    class="btn nav-btn"
                    matTooltip="{{ 'chat.call' | translate: 'Позвонить' }}"
                  >
                    <mat-icon>phone</mat-icon>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          *ngIf="dataService.activChatId === null"
          class="no-chat-selected-placeholder d-flex justify-content-center align-items-center h-100"
        >
          <p class="text-muted h4">
            {{ 'chat.noChatSelected' | translate: 'Чат не выбран' }}
          </p>
        </div>
        <!-- end chat user head -->

        <div
          class="chat-content-wrapper"
          *ngIf="dataService.activChatId !== null"
        >
          <div class="chat-content-inner">
            <!-- start chat conversation -->
            <perfect-scrollbar
              id="scroll"
              class="msgs chat-conversation p-3 p-lg-4"
              [ngClass]="{ 'format-panel-open': isFormatPanelOpen }"
              (psYReachStart)="onReachStart()"
              (psScrollY)="onScroll()"
            >
              <ul
                class="list-unstyled mb-0"
                style="min-height: 100% !important"
              >
                <li
                  *ngIf="dataService.loadingMoreMessages"
                  class="text-center my-2 loading-messages-indicator"
                >
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">{{
                      'chat.loading' | translate: 'Загрузка...'
                    }}</span>
                  </div>
                </li>
                <li
                  *ngIf="!hasMoreMessagesToLoad && displayedMessages.length > 0"
                  class="text-center my-3 beginning-indicator"
                >
                  <span class="text-muted">{{
                    dataService.isSearching.getValue()
                      ? ('chat.noMoreResults'
                        | translate: 'Больше результатов нет')
                      : ('chat.noMoreMessages' | translate: 'Начало переписки')
                  }}</span>
                </li>
                <li
                  *ngIf="
                    !dataService.loadingMessagesStatus.getValue() &&
                    !dataService.loadingMoreMessages &&
                    displayedMessages.length === 0 &&
                    dataService.activChatId !== null
                  "
                  class="text-center empty-chat-indicator"
                >
                  <span class="text-muted">{{
                    dataService.isSearching.getValue()
                      ? ('chat.noResults' | translate: 'Ничего не найдено')
                      : ('chat.emptyChat' | translate: 'Нет сообщений')
                  }}</span>
                </li>
                <li
                  *ngFor="let data of displayedMessages; let i = index"
                  [ngClass]="{ right: data.align === 'right' }"
                  [attr.data-message-id]="data.id"
                >
                  <div class="conversation-list" *ngIf="!data.isToday">
                    <div class="chat-avatar">
                      <img
                        *ngIf="data.profile"
                        src="{{ data.profile }}"
                        class="rounded-circle avatar-xs"
                        alt=""
                      />
                      <div class="avatar-xs" *ngIf="!data.profile">
                        <span
                          class="avatar-title rounded-circle avatar-initials"
                        >
                          {{ getInitials(data.name) }}
                        </span>
                      </div>
                    </div>

                    <div class="user-chat-content">
                      <div class="ctext-wrap">
                        <div class="ctext-wrap-content">
                          <p class="mb-0" [innerHTML]="data.text | safeHtml">
                            <span class="animate-typing" *ngIf="data.istyping">
                              <span class="dot ml-1"></span>
                              <span class="dot ml-1"></span>
                              <span class="dot ml-1"></span>
                            </span>
                          </p>

                          <ul
                            class="list-inline message-img mb-0"
                            *ngIf="data.isimage"
                          >
                            <div>
                              <a
                                class="popup-img d-inline-block m-1"
                                (click)="download(data.fileContent)"
                                title="Project 1"
                              >
                                <img
                                  [src]="
                                    'catService/file/Download?chatId=' +
                                    dataService.activChatId +
                                    '&file=' +
                                    data.fileContent
                                  "
                                  alt=""
                                  class="rounded border"
                                />
                              </a>
                            </div>
                          </ul>

                          <div class="card p-2 mb-2" *ngIf="data.isfile">
                            <div class="media align-items-center">
                              <div class="media-body">
                                <div class="text-left">
                                  <h5 class="font-size-14 mb-1">
                                    {{ data.fileContent }}
                                  </h5>
                                  <p class="text-muted font-size-13 mb-0">
                                    {{ data.fileSize }}
                                  </p>
                                </div>
                              </div>

                              <div class="ml-4">
                                <ul class="list-inline mb-0 font-size-20">
                                  <li class="list-inline-item">
                                    <a
                                      (click)="download(data.fileContent)"
                                      class="text-muted"
                                    >
                                      <mat-icon>cloud_download</mat-icon>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <p class="chat-time mb-0">
                            <i class="ri-time-line align-middle"></i>
                            <span class="align-middle" *ngIf="data.time">{{
                              data.time | date: 'dd.MM.yyyy HH:mm:ss'
                            }}</span>
                          </p>
                        </div>

                        <div
                          class="dropdown align-self-start"
                          ngbDropdown
                          container="body"
                          [placement]="
                            data.align === 'right'
                              ? ['auto', 'top-end']
                              : ['auto', 'top-start']
                          "
                        >
                          <a
                            class="dropdown-toggle"
                            role="button"
                            ngbDropdownToggle
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <mat-icon>more_vert</mat-icon>
                          </a>
                          <div
                            class="dropdown-menu"
                            ngbDropdownMenu
                            [ngClass]="{
                              'dropdown-menu-end': data.align === 'right'
                            }"
                          >
                            <a
                              class="dropdown-item"
                              style="width: min-content"
                              (click)="copyText(data.text)"
                            >
                              <mat-icon
                                style="color: rgba(0, 0, 0, 0.54) !important"
                                >file_copy</mat-icon
                              >{{ 'chat.copy' | translate: 'Копировать' }}
                            </a>
                            <a
                              *ngIf="data.align"
                              class="dropdown-item"
                              (click)="edit(data)"
                            >
                              <mat-icon
                                style="color: rgba(0, 0, 0, 0.54) !important"
                                >edit</mat-icon
                              >
                              {{ 'chat.edit' | translate: 'Изменить' }}
                            </a>
                            <a
                              *ngIf="dataService.user.role == 'lector'"
                              class="dropdown-item"
                              (click)="remove(data.id)"
                            >
                              <mat-icon
                                style="color: rgba(0, 0, 0, 0.54) !important"
                                >delete</mat-icon
                              >
                              {{ 'chat.delete' | translate: 'Удалить' }}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="ctext-wrap" *ngIf="data.message2">
                        <div class="ctext-wrap-content">
                          <p class="mb-0">
                            {{ data.message2 }}
                          </p>
                          <p class="chat-time mb-0">
                            <i class="ri-time-line align-middle"></i>
                            <span class="align-middle" *ngIf="data.time">{{
                              data.time | date: 'dd.MM.yyyy HH:mm:ss'
                            }}</span>
                          </p>
                        </div>
                        <div
                          class="dropdown align-self-start"
                          ngbDropdown
                          container="body"
                          [placement]="
                            data.align === 'right'
                              ? ['auto', 'top-end']
                              : ['auto', 'top-start']
                          "
                        >
                          <a
                            class="dropdown-toggle"
                            href="#"
                            role="button"
                            ngbDropdownToggle
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <mat-icon>more_vert</mat-icon>
                          </a>
                          <div
                            class="dropdown-menu"
                            ngbDropdownMenu
                            [ngClass]="{
                              'dropdown-menu-end': data.align === 'right'
                            }"
                          >
                            <a
                              class="dropdown-item"
                              (click)="copyText(data.text)"
                            >
                              <mat-icon
                                style="color: rgba(0, 0, 0, 0.54) !important"
                                >file_copy</mat-icon
                              >{{ 'chat.copy' | translate: 'Копировать' }}
                            </a>
                            <a
                              *ngIf="dataService.user.role == 'lector'"
                              class="dropdown-item"
                              (click)="remove(data.id)"
                            >
                              <mat-icon
                                style="color: rgba(0, 0, 0, 0.54) !important"
                                >delete</mat-icon
                              >
                              {{ 'chat.delete' | translate: 'Удалить' }}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="conversation-name">{{ data.name }}</div>
                    </div>
                  </div>
                  <div class="chat-day-title" *ngIf="data.isToday">
                    <span class="title">Today</span>
                  </div>
                </li>
              </ul>
            </perfect-scrollbar>
            <!-- end chat conversation end -->
          </div>

          <!-- start chat input section -->
          <div class="chat-input-container">
            <div
              class="p-3 chat-input-section"
              [ngClass]="{ 'expanded-format': isFormatPanelOpen }"
            >
              <div class="row no-gutters message-input-container">
                <div class="col">
                  <div class="message-input-wrapper">
                    <button
                      type="button"
                      (click)="toggleFormatPanel()"
                      class="btn format-toggle-btn"
                      matTooltip="{{
                        (isFormatPanelOpen
                          ? 'chat.hideFormat'
                          : 'chat.showFormat'
                        )
                          | translate
                            : (isFormatPanelOpen
                                ? 'Скрыть форматирование'
                                : 'Показать форматирование')
                      }}"
                    >
                      <mat-icon>{{
                        isFormatPanelOpen ? 'unfold_less' : 'text_format'
                      }}</mat-icon>
                    </button>

                    <div class="format-panel" *ngIf="isFormatPanelOpen">
                      <div class="format-buttons">
                        <button
                          type="button"
                          class="btn format-btn"
                          [ngClass]="{ active: isActive('bold') }"
                          (click)="applyFormat('bold')"
                          matTooltip="{{
                            'button.format.bold' | translate: 'Жирный'
                          }}"
                        >
                          <mat-icon>format_bold</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="btn format-btn"
                          [ngClass]="{ active: isActive('italic') }"
                          (click)="applyFormat('italic')"
                          matTooltip="{{
                            'button.format.italic' | translate: 'Курсив'
                          }}"
                        >
                          <mat-icon>format_italic</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="btn format-btn"
                          [ngClass]="{ active: isActive('underline') }"
                          (click)="applyFormat('underline')"
                          matTooltip="{{
                            'button.format.underlined'
                              | translate: 'Подчеркнутый'
                          }}"
                        >
                          <mat-icon>format_underlined</mat-icon>
                        </button>
                        <span class="divider"></span>
                        <button
                          type="button"
                          class="btn format-btn"
                          [ngClass]="{ active: isActive('ul') }"
                          (click)="applyFormat('ul')"
                          matTooltip="{{
                            'button.format.listBulleted'
                              | translate: 'Маркированный список'
                          }}"
                        >
                          <mat-icon>format_list_bulleted</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="btn format-btn"
                          [ngClass]="{ active: isActive('ol') }"
                          (click)="applyFormat('ol')"
                          matTooltip="{{
                            'button.format.listNumbered'
                              | translate: 'Нумерованный список'
                          }}"
                        >
                          <mat-icon>format_list_numbered</mat-icon>
                        </button>
                        <span class="divider"></span>
                        <button
                          type="button"
                          class="btn format-btn"
                          [ngClass]="{ active: isActive('quote') }"
                          (click)="applyFormat('quote')"
                          matTooltip="{{
                            'button.format.quote' | translate: 'Цитата'
                          }}"
                        >
                          <mat-icon>format_quote</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="btn format-btn"
                          [ngClass]="{ active: isActive('code') }"
                          (click)="applyFormat('code')"
                          matTooltip="{{
                            'button.format.code' | translate: 'Код'
                          }}"
                        >
                          <mat-icon>code</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="btn format-btn"
                          [ngClass]="{ active: isActive('link') }"
                          (click)="applyFormat('link')"
                          matTooltip="{{
                            'button.format.link' | translate: 'Вставить ссылку'
                          }}"
                        >
                          <mat-icon>link</mat-icon>
                        </button>
                      </div>
                    </div>

                    <div
                      class="input-area"
                      [ngClass]="{ expanded: isFormatPanelOpen }"
                    >
                      <textarea
                        #messageTextarea
                        [(ngModel)]="currentMsg.text"
                        (select)="onSelectionChange()"
                        (keyup)="onSelectionChange()"
                        (keyup.enter)="
                          !isFormatPanelOpen &&
                            !dataService.activChat?.isCompletedForUser &&
                            sendMsg()
                        "
                        (input)="
                          !isFormatPanelOpen && autoResize(messageTextarea)
                        "
                        class="form-control"
                        [readonly]="dataService.activChat?.isCompletedForUser"
                        [ngClass]="{
                          'form-control-lg': !isFormatPanelOpen,
                          'expanded-textarea': isFormatPanelOpen,
                          'readonly-textarea':
                            dataService.activChat?.isCompletedForUser
                        }"
                        placeholder="{{
                          dataService.activChat?.isCompletedForUser
                            ? ('chat.chatIsReadOnly'
                              | translate: 'Чат только для чтения')
                            : ('chat.enterMsg' | translate: 'Введите сообщение')
                        }}"
                      ></textarea>
                    </div>
                    <div
                      class="chat-input-links"
                      [ngClass]="{ 'expanded-links': isFormatPanelOpen }"
                    >
                      <ul class="list-inline mb-0">
                        <li *ngIf="isEdit" class="list-inline-item">
                          <button
                            type="button"
                            (click)="stopEdit()"
                            class="btn"
                            matTooltip="{{
                              'chat.cancel' | translate: 'Отмена'
                            }}"
                          >
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </li>
                        <li
                          *ngIf="!isEdit && !hasText"
                          class="list-inline-item"
                        >
                          <input
                            #fileInput
                            hidden="true"
                            type="file"
                            (change)="uploadFiles($event.target)"
                          />
                          <button
                            type="button"
                            (click)="attachFileClick(fileInput)"
                            class="btn"
                            [disabled]="
                              dataService.activChat?.isCompletedForUser
                            "
                            matTooltip="{{
                              'chat.attachFile' | translate: 'Прикрепить файл'
                            }}"
                            ng-reflect-tooltip-class="tooltip"
                          >
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </li>
                        <li class="list-inline-item">
                          <button
                            type="submit"
                            (click)="sendMsg()"
                            class="btn btn-send"
                            [disabled]="
                              !hasText ||
                              dataService.activChat?.isCompletedForUser
                            "
                            matTooltip="{{
                              'chat.send' | translate: 'Отправить'
                            }}"
                          >
                            <mat-icon>send</mat-icon>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end chat input section -->
        </div>
      </div>
      <!-- end chat conversation section -->
    </div>
  </div>
</div>
